import 'polyfills/browser';
import 'core-js/stable';
import 'regenerator-runtime/runtime';

import SignUpPage from 'components/Landing/SignUpPage/SignUpPage';

import { registerComponents } from '../src/registrations';

registerComponents({ SignUpPage });
